// Vendors
import { useEffect } from 'react';
// Contexts
import { useAppContextConsumerHook } from 'contexts/app.context';
// Constants
import { ENTRYPOINT_ORCHESTRATOR_STATE_CUSTOM_ACTION } from './constants/entrypoint-orchestrator.hook.constants';
// Event Handlers
import { LogHandlers } from 'handlers/log.handlers';
// Types
import { EntrypointOrchestratorHookType } from './types/entrypoint-orchestrator.hook.type';

const useEntrypointOrchestratorHook = (): EntrypointOrchestratorHookType => {
  const { currentState } = useAppContextConsumerHook();

  const { handleSendCustomActionEvent } = LogHandlers();

  useEffect(() => {
    handleSendCustomActionEvent(`${ENTRYPOINT_ORCHESTRATOR_STATE_CUSTOM_ACTION}${currentState}`);
  }, [currentState]);

  return {
    currentState,
  };
};

export { useEntrypointOrchestratorHook };
